import { CheckCircle2, Circle } from 'lucide-react'
import React from 'react'

interface ToolCallPillProps {
  toolName: string
  isCompleted: boolean
}

/**
 * A pill-style UI component that displays a tool call with completion status.
 */
export function ToolCallPill({ toolName, isCompleted }: ToolCallPillProps) {
  return (
    <div className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-magazine-pearl hover:bg-magazine-pearl/80 rounded-full transition-colors cursor-pointer">
      {isCompleted ? (
        <CheckCircle2 className="w-3.5 h-3.5 text-magazine-sage" />
      ) : (
        <Circle className="w-3.5 h-3.5 text-magazine-dust" />
      )}
      <span className="font-sans text-caption text-magazine-ash">
        {toolName}
      </span>
    </div>
  )
}
